import { render, staticRenderFns } from "./Modulestatus.vue?vue&type=template&id=826e619c&scoped=true&"
import script from "./Modulestatus.vue?vue&type=script&lang=js&"
export * from "./Modulestatus.vue?vue&type=script&lang=js&"
import style0 from "./Modulestatus.vue?vue&type=style&index=0&id=826e619c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826e619c",
  null
  
)

export default component.exports